import { Typography } from "@kaltura/ds-react-components";
import { translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { isFirefox } from "react-device-detect";
import { BaseInstructionsDrawerProps, InstructionsDrawer } from "./InstructionsDrawer";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";
import { Copy24Icon } from "@kaltura/ds-react-icons";
import { CopyButton } from "./CopyButton";
import { ChromeLogo } from "./ChromeLogo";

export const isIncompatibleBrowser = isFirefox;

/**
 * Bottom drawer with unsupported browser instructions.
 */
export const IncompatibleBrowserInstructionsDrawer = (props: BaseInstructionsDrawerProps) => {
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

    return (
        <ButtonAnalyticsProvider location={"Modal - Incompatible Browser"}>
            <InstructionsDrawer
                {...props}
                title={translate("Incompatible browser")}
                logo={<ChromeLogo />}
                closeAnalyticsName={"Close incompatible browser modal"}
            >
                <Typography>
                    {translate(
                        "Your current browser may not be compatible with this functionality. Copy the link below and paste it into Chrome or Safari (not in a private window) to continue."
                    )}
                </Typography>

                <div>
                    <CopyButton
                        size={"large"}
                        startIcon={<Copy24Icon />}
                        fullWidth={isSmallScreen}
                        copyText={window.location.href}
                    >
                        {translate("Copy link")}
                    </CopyButton>
                </div>
            </InstructionsDrawer>
        </ButtonAnalyticsProvider>
    );
};
